import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/google-icon.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Login", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "google-icon"
}, null, -1)
const _hoisted_3 = { class: "info-center min" }
const _hoisted_4 = ["href"]

import { reactive, ref } from 'vue';
import { useAccountStore } from '@/stores/account';
import { useRouter } from 'vue-router';
import { useErrors } from '@/utils/use-errors';
import { getSignUpLink, hasSignUpLink } from '@/utils/origin'
import VAuthInput from '@/components/VAuthInput.vue';
import VButton from '@/components/VButton.vue'
import MailIcon from '@/components/icons/other/MailIcon.vue'
import LockIcon from '@/components/icons/other/LockIcon.vue'
import VDivider from '@/components/VDivider.vue'
import { useTitle } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLoginForm',
  setup(__props) {

const values = reactive({ login: "", password: "" })
const { errors, checkRequired } = useErrors(values)

const accountStore = useAccountStore()
const router = useRouter()

const pending = ref(false)
const signIn = async (e: Event) => {
  e.preventDefault()
  if (!checkRequired([ 'login', 'password' ])) return
  pending.value = true
  try {
    await accountStore.login(values)
    router.push("/")
  } catch(e) {
    console.warn(e)
    errors.password = "Invalid login or password"
    pending.value = false
  }
}

useTitle("Sign In | Reply200")


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("form", {
    class: "auth__form",
    onSubmit: signIn
  }, [
    _hoisted_1,
    _createVNode(VAuthInput, {
      modelValue: values.login,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((values.login) = $event)),
      error: _unref(errors).login,
      icon: MailIcon,
      placeholder: "Your Email"
    }, null, 8, ["modelValue", "error"]),
    _createVNode(VAuthInput, {
      modelValue: values.password,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((values.password) = $event)),
      error: _unref(errors).password,
      icon: LockIcon,
      placeholder: "Password",
      type: "password"
    }, null, 8, ["modelValue", "error"]),
    _createVNode(_component_router_link, {
      to: "/auth/forgot",
      class: "text-center"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Forgot password?")
      ]),
      _: 1
    }),
    _createVNode(VButton, {
      class: "login-button primary mb-3",
      type: "submit",
      disabled: pending.value
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Log in ")
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(VDivider, { class: "mb-3" }, {
      default: _withCtx(() => [
        _createTextVNode("or continue with")
      ]),
      _: 1
    }),
    _createVNode(VButton, {
      class: "clear google mb-2",
      type: "button",
      onClick: _unref(accountStore).authByGoogle
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" Google ")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode("Not have an account? "),
      (_unref(hasSignUpLink)())
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _unref(getSignUpLink)()
          }, "Sign up", 8, _hoisted_4))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: _unref(getSignUpLink)()
          }, {
            default: _withCtx(() => [
              _createTextVNode("Sign up")
            ]),
            _: 1
          }, 8, ["to"]))
    ])
  ], 32))
}
}

})